import AppStore from "./AppStore";
import { buildClassName } from "./util";

// id: "762cdda2-575f-4544-a851-f9ec5f9f33bb"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooter762cdda2575f4544A851F9ec5f9f33bb(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const Logo = AppStore.presets["Logo"];
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooter762cdda2575f4544A851F9ec5f9f33bb footer`}>
      {props["links"] || <Navigation className="Links3aa0d23dC6da4e90943b318722877b04" parentTag={buildClassName("Links3aa0d23dC6da4e90943b318722877b04", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo className="Logo804285e5Aba84bec8f6c24ca9d9aaf94" parentTag={buildClassName("Logo804285e5Aba84bec8f6c24ca9d9aaf94", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />}
      </div>
      {props["copyright"] || <GroupCopyright className="Copyright860e8c5a80dd4097Ad60A14c8c3e9905" parentTag={buildClassName("Copyright860e8c5a80dd4097Ad60A14c8c3e9905", parentTag)} {...props} />}
      {props["groupflow"] || <GroupFlowTag className="Groupflow80ec5f39E7f641c3B2315b8e254f0c64" parentTag={buildClassName("Groupflow80ec5f39E7f641c3B2315b8e254f0c64", parentTag)} {...props} />}
    </footer>
  );
}

// id: "804285e5-aba8-4bec-8f6c-24ca9d9aaf94"
// title: ""
// type: :gf_preset
// key: "logo"
// parent_id: "762cdda2-575f-4544-a851-f9ec5f9f33bb"
export function Logo804285e5Aba84bec8f6c24ca9d9aaf94(props: any) {
  const Logo = AppStore.presets["Logo"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Logo className="Logo804285e5Aba84bec8f6c24ca9d9aaf94" parentTag={buildClassName("Logo804285e5Aba84bec8f6c24ca9d9aaf94", parentTag)} logoType="FOOTER" contentSlug="footer-logo" {...props} />
  );
}

// id: "860e8c5a-80dd-4097-ad60-a14c8c3e9905"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "762cdda2-575f-4544-a851-f9ec5f9f33bb"
export function Copyright860e8c5a80dd4097Ad60A14c8c3e9905(props: any) {
  const GroupCopyright = AppStore.presets["GroupCopyright"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="Copyright860e8c5a80dd4097Ad60A14c8c3e9905" parentTag={buildClassName("Copyright860e8c5a80dd4097Ad60A14c8c3e9905", parentTag)} {...props} />
  );
}

// id: "3aa0d23d-c6da-4e90-943b-318722877b04"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "762cdda2-575f-4544-a851-f9ec5f9f33bb"
export function Links3aa0d23dC6da4e90943b318722877b04(props: any) {
  const Navigation = AppStore.presets["Navigation"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links3aa0d23dC6da4e90943b318722877b04" parentTag={buildClassName("Links3aa0d23dC6da4e90943b318722877b04", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "80ec5f39-e7f6-41c3-b231-5b8e254f0c64"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "762cdda2-575f-4544-a851-f9ec5f9f33bb"
export function Groupflow80ec5f39E7f641c3B2315b8e254f0c64(props: any) {
  const GroupFlowTag = AppStore.presets["GroupFlowTag"];
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="Groupflow80ec5f39E7f641c3B2315b8e254f0c64" parentTag={buildClassName("Groupflow80ec5f39E7f641c3B2315b8e254f0c64", parentTag)} {...props} />
  );
}

// id: "14638ad3-4f02-4c64-a3c1-200172d670a8"
// title: ""
// type: :text
// key: "logoType"
// parent_id: "804285e5-aba8-4bec-8f6c-24ca9d9aaf94"
export const LogoType14638ad34f024c64A3c1200172d670a8 = "FOOTER";

// id: "b118126a-78b3-470f-8c0e-a879bc8d0210"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "3aa0d23d-c6da-4e90-943b-318722877b04"
export const NavMenuSlugB118126a78b3470f8c0eA879bc8d0210 = "footer-nav";

// id: "d27cc0b0-8656-40fc-9003-3985feb4d9b5"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "804285e5-aba8-4bec-8f6c-24ca9d9aaf94"
export const ContentSlugD27cc0b0865640fc90033985feb4d9b5 = "footer-logo";

const Components = {
  DefaultFooter762cdda2575f4544A851F9ec5f9f33bb,
  Logo804285e5Aba84bec8f6c24ca9d9aaf94,
  Copyright860e8c5a80dd4097Ad60A14c8c3e9905,
  Links3aa0d23dC6da4e90943b318722877b04,
  Groupflow80ec5f39E7f641c3B2315b8e254f0c64,
  LogoType14638ad34f024c64A3c1200172d670a8,
  NavMenuSlugB118126a78b3470f8c0eA879bc8d0210,
  ContentSlugD27cc0b0865640fc90033985feb4d9b5
}

export default Components;